import { render, staticRenderFns } from "./DetalleSolicitudComprobacionRepresentacion.vue?vue&type=template&id=007071aa&"
import script from "./DetalleSolicitudComprobacionRepresentacion.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudComprobacionRepresentacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleSolicitudComprobacionRepresentacion.vue"
export default component.exports